export default __webpack_public_path__ + "static/media/noImage.376c3986.svg";